import React, {useEffect, useState} from 'react';
import {
  fetchUsersById,
  fetchUsersByIdForUpdateProfile,
  getAllApprovedAds,
  getAllApprovedJobs,
  getAllChapters,
  getAllEventTypesByQuery,
  setChapterById,
} from '../../../Store/Actions';
import {useDispatch, useSelector} from 'react-redux';
import {
  DefaultPaginationValuesForPastEvents,
  createSelectionOptionsUtil,
  getLocalStorageUserInfo,
} from '../../../Util/commonUtility';
import PbssInternationalComponent from '../../../Components/UserComponents/PbssInternational';
import {LoadMoreSize} from './../../../Util/commonUtility';
import {
  getAllPastEvents,
  getAllUserEvents,
} from '../../../Store/Actions/events';
import moment from 'moment';
import {useNavigate, useParams} from 'react-router-dom';
import {getAllEventSponsorLogos} from '../../../Store/Actions/eventRegister';
import useLocalization from '../../../Localization';

const PbssInContainer = () => {
  let dispatch = useDispatch();
  const {fetchUserData} = useSelector(({users}) => users);
  const {getAllEventRegistrationLogos} = useSelector(
    ({eventRegister}) => eventRegister,
  );
  const {ApplicationString} = useLocalization();
  const {getApprovedJobs} = useSelector(({jobs}) => jobs);
  const {getApprovedAds} = useSelector(({ads}) => ads);
  const [allApprovedJobsData, setAllApprovedJobsData] = useState([]);
  const [allApprovedAdsData, setAllApprovedAdsData] = useState([]);
  const [allSponsorsList, setAllSponsorList] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(2);
  const [startIndexAds, setStartIndexAds] = useState(0);
  const [endIndexAds, setEndIndexAds] = useState(3);
  const [totalJobs, setTotalJobs] = useState(0);
  const [totalAds, setTotalAds] = useState(0);
  const [loggedIn, setLoggedIn] = useState(false);
  const {allChapters} = useSelector(({chapters}) => chapters);
  const [countData, setCountData] = useState(LoadMoreSize);
  const [totalEventCountChapter, setTotalEventCountChapter] = useState(0);
  const {allEvents, allUserEvents} = useSelector(({events}) => events);
  const [getAllEventData, setGetAllEventData] = useState();
  const {chapterId} = useParams();
  const [selectedChapterValue, setSelectedChapterValue] = useState('');
  const [selectedEventTypeValue, setSelectedEventTypeValue] = useState('');
  const [selectedDateValue, setSelectedDateValue] = useState('');
  const {allEventTypesQueryData} = useSelector(({eventTypes}) => eventTypes);
  const [chaptersList, setChaptersList] = useState([]);
  const [eventTypesList, setEventTypesList] = useState([]);
  const [countLoadMoreData, setCountLoadMoreData] = useState(2);
  const [totalEventCount, setTotalEventCount] = useState(0);
  const [pastEventData, setPastEventData] = useState();
  const [getAllPastEventData, setGetAllPastEventData] = useState();
  const [allEventSponsorLogos, setEventSponsorLogos] = useState();
  const {allPastEvents} = useSelector(({events}) => events);
  const [selectedYearValue, setSelectedYearValue] = React.useState('');
  const [eventData, setEventData] = useState([]);
  const {chapterName} = useParams();
  const [pagination, setPagination] = React.useState({
    page: DefaultPaginationValuesForPastEvents.PAGE,
    pagecount: DefaultPaginationValuesForPastEvents.PAGE_SIZE,
    totalPages: DefaultPaginationValuesForPastEvents.TOTAL_PAGES,
  });
  const [dateToggle, setdateToggle] = useState(true);
  const [totalPastEventsPages, setTotalPastEventsPages] = useState();

  const dateOrderHandler = () => {
    if (dateToggle) {
      dispatch(
        getAllUserEvents(
          selectedEventTypeValue,
          selectedChapterValue,
          'desc',
          'event_start_date',
        ),
      );
    } else {
      dispatch(
        getAllUserEvents(
          selectedEventTypeValue,
          selectedChapterValue,
          'asc',
          'event_start_date',
        ),
      );
    }
    setdateToggle(!dateToggle);
  };
  const navigate = useNavigate();
  const userInfo = getLocalStorageUserInfo();
  const userId = userInfo?.id;

  useEffect(() => {
    userId && dispatch(fetchUsersByIdForUpdateProfile(userId));
  }, []);

  useEffect(() => {
    dispatch(
      getAllUserEvents(
        selectedChapterValue,
        selectedEventTypeValue,
        selectedDateValue,
      ),
    );
    dispatch(getAllEventSponsorLogos());
  }, []);

  const handleNext = () => {
    if (endIndex + 1 < totalJobs) {
      setStartIndex(endIndex + 1);
      setEndIndex(endIndex + 3);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 3);
      setEndIndex(endIndex - 3);
    }
  };
  const handleNextAds = () => {
    if (endIndexAds + 1 < totalAds) {
      setStartIndexAds(endIndexAds + 1);
      setEndIndexAds(endIndexAds + 4);
    }
  };

  const handlePrevAds = () => {
    if (startIndexAds > 0) {
      setStartIndexAds(startIndexAds - 4);
      setEndIndexAds(endIndexAds - 4);
    }
  };

  useEffect(() => {
    if (fetchUserData) {
      dispatch(setChapterById(fetchUserData?.data?.local_chapter_id));
    } else {
      const userInfo = getLocalStorageUserInfo();
      const userId = userInfo ? userInfo?.id : '';
      if (userId) {
        dispatch(fetchUsersById(userId));
      }
    }
  }, [fetchUserData]);

  useEffect(() => {
    if (getApprovedJobs) {
      const Data = getApprovedJobs?.data?.jobs?.slice(startIndex, endIndex + 1);
      setAllApprovedJobsData(Data);
      setTotalJobs(getApprovedJobs?.data?.totalCount);
    } else {
      dispatch(getAllApprovedJobs());
    }
  }, [getApprovedJobs, startIndex, endIndex]);

  useEffect(() => {
    if (getAllEventRegistrationLogos) {
      setEventSponsorLogos(getAllEventRegistrationLogos);
    }
  }, [getAllEventRegistrationLogos]);

  useEffect(() => {
    if (getApprovedAds) {
      const Data = getApprovedAds?.data?.ads?.slice(
        startIndexAds,
        endIndexAds + 1,
      );
      setAllApprovedAdsData(Data);
      setTotalAds(getApprovedAds?.data?.totalCount);
    } else {
      dispatch(getAllApprovedAds());
    }
  }, [getApprovedAds, startIndexAds, endIndexAds]);

  // useEffect(() => {
  //   if (allSponsors) {
  //     setAllSponsorList(allSponsors?.data?.sponsors);
  //   } else {
  //     dispatch(getAllSponsors());
  //   }
  // }, [allSponsors]);

  useEffect(() => {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      setLoggedIn(true);
    }
  }, []);

  // useEffect(() => {
  //   if (getEventsDataByChapters) {
  //     const Data =
  //       getEventsDataByChapters?.data?.events.length > 0
  //         ? getEventsDataByChapters?.data?.events?.slice(0, countData)
  //         : getEventsDataByChapters?.data?.events;
  //     setGetAllEventDataByChapter(Data);
  //     setTotalEventCountChapter(getEventsDataByChapters?.data?.totalCount);
  //   }
  // }, [getEventsDataByChapters, countData]);

  // useEffect(() => {
  //   if (loggedIn && defaultChapterValue !== false) {
  //     dispatch(getEventsByChapters(defaultChapterValue));
  //   }
  // }, [loggedIn, dispatch, defaultChapterValue]);

  // useEffect(() => {
  //   if (getAllEventDataByChapter) {
  //     const updatedEventData =
  //       getAllEventDataByChapter.length > 0
  //         ? getAllEventDataByChapter.map((item) => {
  //             return {
  //               key: item.id,
  //               id: item.id,
  //               sponsorshipAvailable: `${
  //                 Array.isArray(item.sponsors) ? item.sponsors.length : 0
  //               } Sponsorship Available`,
  //               speakers: Array.isArray(item.speakers)
  //                 ? item.speakers.map((speakers) => {
  //                     return (
  //                       <div key={speakers}>
  //                         {speakers.first_name + ' ' + speakers.last_name}
  //                       </div>
  //                     );
  //                   })
  //                 : '',
  //               date: item.date,
  //               eventName: item.name,
  //               registerText: 'Register Now',
  //               location: item.place,
  //               price: '295',
  //               category: 'PBSS International Boston - PBSS',
  //               eventType: item?.event_type_name,
  //               eventChapter: item?.chapter_name,
  //             };
  //           })
  //         : null;
  //     setEventData(updatedEventData);
  //   }
  // }, [getAllEventDataByChapter]);

  const handlePaginationChange = (current, pageSize) => {
    setPagination({
      ...pagination,
      page: current,
      // pagecount: pageSize,
    });
  };

  const handleYearFilter = (value) => {
    if (value === 'clear') {
      dispatch(getAllPastEvents(pagination, ''));
      setSelectedYearValue('');
    } else {
      dispatch(getAllPastEvents(pagination, value));
      setSelectedYearValue(value);
    }
  };

  const handleChapterClick = (chapterId, chapterName) => {
    dispatch(setChapterById(chapterId));
    navigate(`/chapter/${chapterName}`);
  };
  useEffect(() => {
    if (allPastEvents) {
      const Data = allPastEvents?.data?.events;
      setGetAllPastEventData(Data);
      setTotalPastEventsPages(allPastEvents?.data?.totalPage);
      setPagination({
        ...pagination,
        page: allPastEvents?.data?.currentPage,
        totalPages: allPastEvents?.data?.totalPage,
        totalCount: allPastEvents?.data?.totalCount,
      });
    } else {
      dispatch(getAllPastEvents(pagination, selectedYearValue));
    }
  }, [allPastEvents?.data]);

  useEffect(() => {
    if (getAllPastEventData) {
      const updatedPastEventData = getAllPastEventData.map((item) => {
        return {
          key: item.id,
          name: item.name,
          event_date: moment(item.event_start_date_time)
            .utcOffset(0)
            .format('DD MMM YYYY'),
          event_type: item.event_type_name,
          chapter_name: item?.local_chapter_normalized_name
            ? item?.local_chapter_normalized_name
            : item.local_chapter_name,
        };
      });
      setPastEventData(updatedPastEventData);
    }
  }, [getAllPastEventData]);

  useEffect(() => {
    if (allChapters) {
      let filteredChaptersForMap = allChapters?.data?.chapters?.filter(
        (chapter) => chapter.is_visible_on_map,
      );
      const chapters = createSelectionOptionsUtil(
        filteredChaptersForMap,
        'id',
        'name',
      );
      setChaptersList([...chapters]);
    } else {
      dispatch(getAllChapters());
    }
  }, [allChapters, dispatch]);

  useEffect(() => {
    if (allEventTypesQueryData?.forMaster) {
      const eventTypes = createSelectionOptionsUtil(
        allEventTypesQueryData?.forMaster?.data?.eventTypes,
        'id',
        'name',
        null,
        'eventType',
      );
      setEventTypesList([ ...eventTypes]);
    } else {
      dispatch(
        getAllEventTypesByQuery('', '', '', {
          page: 1,
          pageCount: 100,
        }),
      );
    }
  }, [allEventTypesQueryData?.forMaster, dispatch]);

  useEffect(() => {
    if (allUserEvents) {
      const Data = allUserEvents?.data?.events;
      setGetAllEventData(Data);
      setTotalEventCount(allUserEvents?.data?.totalCount);
    } else {
      dispatch(
        getAllUserEvents(
          selectedEventTypeValue,
          selectedChapterValue,
          selectedDateValue,
        ),
      );
    }
  }, [allUserEvents, countData]);

  useEffect(() => {
    if (getAllEventData) {
      const updatedEventData = getAllEventData.map((item) => {
        return {
          key: item.id,
          status: item.status,
          sponsorshipAvailable: `${
            Array.isArray(item.sponsors) ? item.sponsors.length : 0
          } ${ApplicationString['eventCard.sponsorshipAvailable']}`,
          speakers: Array.isArray(item.speakers)
            ? item.speakers.map((speakers) => {
                return speakers.first_name + ' ' + speakers.last_name + ',';
              })
            : '',
          date: moment(item.date).utcOffset(0).format('MMM DD'),
          dateObject: item.formattedDateTime,
          eventName: item.name,
          eventDetails: item.details,
          location: item.place,
          registerText:
            Number(item.status) === 2
              ? ApplicationString['eventCard.cta.registrationClosed']
              : ApplicationString['eventCard.registerNow'],
          price: '295',
          category: 'PBSS International Boston - PBSS',
          eventType: item.event_type_name,
          eventChapter: item?.local_chapter_name,
        };
      });
      setEventData(updatedEventData);
    }
  }, [getAllEventData]);

  useEffect(() => {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      setLoggedIn(true);
    }
  }, []);
  // const filteredEvents =
  //   selectedCategory === 'All Events' ? eventData : eventDataChapters;

  const handleChapterFilter = (value) => {
    if (value === 'clear') {
      dispatch(getAllUserEvents(selectedEventTypeValue, '', selectedDateValue));
      setSelectedChapterValue('');
    } else {
      dispatch(
        getAllUserEvents(selectedEventTypeValue, value, selectedDateValue),
        setSelectedChapterValue(value),
      );
    }
    setCountLoadMoreData(2);
  };
  const handleEventTypeFilter = (value) => {
    if (value === 'clear') {
      dispatch(getAllUserEvents('', selectedChapterValue, selectedDateValue));
      setSelectedEventTypeValue('');
    } else {
      dispatch(
        getAllUserEvents(value, selectedChapterValue, selectedDateValue),
        setSelectedEventTypeValue(value),
      );
    }
    setCountLoadMoreData(2);
  };

  const handleLoadMore = () => {
    setCountData(countData * 2);
    setCountLoadMoreData(countLoadMoreData * 2);
  };

  return (
    <PbssInternationalComponent
      allEventSponsorLogos={allEventSponsorLogos}
      sponsorsData={allSponsorsList}
      allApprovedJobsData={allApprovedJobsData}
      allApprovedAdsData={allApprovedAdsData}
      handleNext={handleNext}
      handlePrev={handlePrev}
      handleNextAds={handleNextAds}
      handlePrevAds={handlePrevAds}
      loggedIn={loggedIn}
      totalEventCountChapter={totalEventCountChapter}
      eventData={eventData}
      totalEventCount={totalEventCount}
      handleLoadMore={handleLoadMore}
      pastEventData={pastEventData}
      handleChapterFilter={handleChapterFilter}
      handleEventTypeFilter={handleEventTypeFilter}
      chaptersList={chaptersList}
      eventTypeList={eventTypesList}
      selectedYearValue={selectedYearValue}
      countLoadMoreData={countLoadMoreData}
      pagination={pagination}
      handleYearFilter={handleYearFilter}
      handlePaginationChange={(page, pageSize) => {
        handlePaginationChange(page, pageSize);
      }}
      handleChapterClick={(chapterId, chapterName) => {
        handleChapterClick(chapterId, chapterName);
      }}
      selectedEventTypeValue={selectedEventTypeValue}
      selectedChapterValue={selectedChapterValue}
      selectedDateValue={selectedDateValue}
      dateToggle={dateToggle}
      dateOrderHandler={dateOrderHandler}
      totalPastEventsPages={totalPastEventsPages}
    />
  );
};

export default PbssInContainer;
